import { Chip } from "@mui/material";

export const COLUMNSVACACIONES = [
  {
    accessorKey: "id",
  },
  {
    header: "Período Vacacional	",
    accessorKey: "periodo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días correspondientes",
    accessorKey: "diasCorrespondientes",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días adicionales",
    accessorKey: "diasAdicionales",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días solicitados",
    accessorKey: "diasSolicitados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días Aprobados",
    accessorKey: "diasGozados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días pendientes",
    accessorKey: "diasPendientes",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSVACACIONESINGRESADAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Empleado",
    accessorKey: "new_empleado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Licencia",
    accessorKey: "new_tipodelicencia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de solicitud",
    accessorKey: "fechaSolicitud",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha desde",
    accessorKey: "fechaDesde",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha hasta",
    accessorKey: "fechaHasta",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días solicitados",
    accessorKey: "diasSolicitados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "estado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000004:
          return (
            <Chip
              label="Vigente"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000005:
          return (
            <Chip
              label="Requiere Más Información"
              sx={{ fontWeight: "bold" }}
              color="warning"
              variant="outlined"
            />
          );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSVACACIONESAPROBADAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Empleado",
    accessorKey: "new_empleado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Licencia",
    accessorKey: "new_tipodelicencia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de solicitud",
    accessorKey: "fechaSolicitud",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha desde",
    accessorKey: "fechaDesde",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha hasta",
    accessorKey: "fechaHasta",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días solicitados",
    accessorKey: "diasSolicitados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días pendientes",
    accessorKey: "diasPendientes",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "estado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000004:
          return (
            <Chip
              label="Vigente"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000005:
          return (
            <Chip
              label="Requiere Más Información"
              sx={{ fontWeight: "bold" }}
              color="warning"
              variant="outlined"
            />
          );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSVACACIONESNOAPROBADAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Empleado",
    accessorKey: "new_empleado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Licencia",
    accessorKey: "new_tipodelicencia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de solicitud",
    accessorKey: "fechaSolicitud",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha desde",
    accessorKey: "fechaDesde",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha hasta",
    accessorKey: "fechaHasta",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días solicitados",
    accessorKey: "diasSolicitados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "estado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000004:
          return (
            <Chip
              label="Vigente"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000005:
          return (
            <Chip
              label="Requiere Más Información"
              sx={{ fontWeight: "bold" }}
              color="warning"
              variant="outlined"
            />
          );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSVACACIONESNEQUIPOINGRESADAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Empleado",
    accessorKey: "new_empleado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Licencia",
    accessorKey: "new_tipodelicencia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de solicitud",
    accessorKey: "fechaSolicitud",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha desde",
    accessorKey: "fechaDesde",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha hasta",
    accessorKey: "fechaHasta",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días solicitados",
    accessorKey: "diasSolicitados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSVACACIONESNEQUIPOAPROBADAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Empleado",
    accessorKey: "new_empleado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Licencia",
    accessorKey: "new_tipodelicencia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de solicitud",
    accessorKey: "fechaSolicitud",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha desde",
    accessorKey: "fechaDesde",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha hasta",
    accessorKey: "fechaHasta",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días solicitados",
    accessorKey: "diasSolicitados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días pendientes",
    accessorKey: "diasPendientes",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSVACACIONESNEQUIPONOADMI = [
  {
    accessorKey: "id",
  },
  {
    header: "Empleado",
    accessorKey: "new_empleado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Licencia",
    accessorKey: "new_tipodelicencia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de solicitud",
    accessorKey: "fechaSolicitud",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha desde",
    accessorKey: "fechaDesde",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha hasta",
    accessorKey: "fechaHasta",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días solicitados",
    accessorKey: "diasSolicitados",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSSUBPERIODOVACACIONAL = [
  {
    accessorKey: "id",
  },
  {
    Header: "Registro de Subperiodo",
    accessorKey: "subperiodo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Subperiodo",
    accessorKey: "name",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Unidad Organizativa",
    accessorKey: "unidadOrganizativa",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha desde Habilitada",
    accessorKey: "fechaDesdeHabilitada",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha hasta  Habilitada",
    accessorKey: "fechaHastaHabilitada",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "% Cumplir Objetivo",
    accessorKey: "cumplirObjetivo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "% Licencias en el Subperiodo para la UO",
    accessorKey: "licenciasSubperiodo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "estado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000004:
          return (
            <Chip
              label="Vigente"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000005:
          return (
            <Chip
              label="Requiere Más Información"
              sx={{ fontWeight: "bold" }}
              color="warning"
              variant="outlined"
            />
          );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];
